import moment from "moment-timezone";

import { FILTER_VALUE_DATE_FORMAT } from "components/table/FilterBarDateTimeRange/FilterBarDateTimeRangeUtils";

/**
 * The calendar day a timestamp falls on in the user's zone, or `null` when the
 * value isn't a usable date.
 */
function toDay(value: unknown, timezoneName: string): string | null {
    if (typeof value !== "string" || value === "") {
        return null;
    }
    const date = moment.tz(value, timezoneName);
    return date.isValid() ? date.format(FILTER_VALUE_DATE_FORMAT) : null;
}

/** Calculate the boundary values (max and min) for due dates */
export function computeDueDateBounds(
    facetedDueDates: Map<unknown, number> | undefined,
    timezoneName: string
): [string, string] | null {
    if (!facetedDueDates) {
        return null;
    }

    let bounds: [string, string] | null = null;

    for (const value of facetedDueDates.keys()) {
        const dueDate = toDay(value, timezoneName);

        if (dueDate !== null) {
            if (bounds === null) {
                bounds = [dueDate, dueDate];
            } else {
                if (dueDate < bounds[0]) {
                    bounds[0] = dueDate;
                }

                if (dueDate > bounds[1]) {
                    bounds[1] = dueDate;
                }
            }
        }
    }
    return bounds;
}
